export const INDEX_OF_COURSEWARE_NAME_IN_BREADCRUMB = 2;

export const BREADCRUMB_TITLE_MIN_CHARS = 40;

export function getBreadcrumbNativeTitle(truncateCrumb, text) {
  if (
    !truncateCrumb ||
    typeof text !== 'string' ||
    text.length < BREADCRUMB_TITLE_MIN_CHARS
  ) {
    return undefined;
  }
  return text;
}

export function isDeepBreadcrumbRoute(pathname) {
  if (!pathname || typeof pathname !== 'string') return false;
  return /\/(course|lesson|activity)\/[^/]+\/pathway\//.test(pathname);
}
